import { z } from 'zod';

export const email = z.string().trim().toLowerCase().max(254).pipe(z.email());

export const signInRequest = z.object({ email });
export type SignInRequest = z.infer<typeof signInRequest>;

/** Identical for known and unknown addresses. */
export const signInResponse = z.object({ challengeId: z.string() });

export const verifyCodeRequest = z.object({
  challengeId: z.string().min(10).max(64),
  code: z.string().regex(/^\d{6}$/),
});
export const verifyLinkRequest = z.object({
  challengeId: z.string().min(10).max(64),
  token: z.string().min(20).max(128),
});
export const verifyInvitationRequest = z.object({ token: z.string().min(20).max(128) });
/** Accepting needs the code emailed to the address, so a forwarded link alone opens nothing. */
export const acceptInvitationRequest = z.object({
  token: z.string().min(20).max(128),
  code: z
    .string()
    .trim()
    .regex(/^\d{6}$/, 'Enter the 6-digit code'),
});
